import React from 'react';
import { ChatComposer } from './ChatComposer';
import { ChatAdvancedOptions, AdvancedOptionsValue } from './ChatAdvancedOptions';
import ContentSuggestions from '@/components/ContentSuggestions';
import { UploadedDocument } from '@/types';
import { ProfilePreferences, UserProfile } from '@/services/profileService';
import CoreStudioMark from '@/components/ui/core-studio-mark';

interface Props {
  greetingName: string;
  composerValue: string;
  onComposerChange: (v: string) => void;
  onSubmit: () => void;
  isBusy: boolean;
  attachedDocument: UploadedDocument | null;
  onAttach: (file: File) => void;
  onDetach: () => void;
  advancedOpen: boolean;
  onToggleAdvanced: () => void;
  advancedValue: AdvancedOptionsValue;
  onAdvancedChange: (v: AdvancedOptionsValue) => void;
  avatarHandleLabel: string | null;
  onEditAvatar: () => void;
  userProfile: UserProfile | null;
  preferences: ProfilePreferences | null;
  userId: string;
  onSuggestionPick: (topic: string) => void;
  onPreferencesUpdated: (prefs: ProfilePreferences) => void;
}

export const ChatEmptyState: React.FC<Props> = ({
  greetingName,
  composerValue,
  onComposerChange,
  onSubmit,
  isBusy,
  attachedDocument,
  onAttach,
  onDetach,
  advancedOpen,
  onToggleAdvanced,
  advancedValue,
  onAdvancedChange,
  avatarHandleLabel,
  onEditAvatar,
  userProfile,
  preferences,
  userId,
  onSuggestionPick,
  onPreferencesUpdated,
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 gap-6">
      <div
        data-tour="chat-greeting"
        className="flex items-center gap-3 text-2xl md:text-3xl font-semibold text-center"
      >
        <CoreStudioMark size={32} />
        <span>Ei, {greetingName}. Tudo pronto pra criar?</span>
      </div>
      <p className="text-sm text-muted-foreground -mt-3 text-center max-w-md">
        Descreva seu carrossel, cole um link do Instagram ou anexe um documento.
      </p>

      <div className="w-full max-w-2xl space-y-3">
        <ChatComposer
          value={composerValue}
          onChange={onComposerChange}
          onSubmit={onSubmit}
          isBusy={isBusy}
          attachedDocument={attachedDocument}
          onAttach={onAttach}
          onDetach={onDetach}
          onToggleAdvanced={onToggleAdvanced}
          variant="empty"
        />
        {advancedOpen && (
          <ChatAdvancedOptions
            value={advancedValue}
            onChange={onAdvancedChange}
            avatarHandleLabel={avatarHandleLabel}
            onEditAvatar={onEditAvatar}
          />
        )}
      </div>

      <div data-tour="chat-suggestions" className="w-full max-w-2xl">
        <ContentSuggestions
          avatarData={preferences?.avatarData}
          preferences={preferences}
          userId={userId}
          userProfile={userProfile}
          onPreferencesUpdated={onPreferencesUpdated}
          compact
          onPick={onSuggestionPick}
        />
      </div>
    </div>
  );
};
